import type { RouteRecordRaw } from "vue-router"
import { NO_ORGANIZATION_PATH, ORGANIZATION_SELECT_PATH } from "../hqAccess"

const Layout = () => import("@/layout/index.vue")
const Login = () => import("@/views/base-page/login/index.vue")
const NoOrganization = () => import("@/views/base-page/no-organization/index.vue")
const OrganizationSelect = () => import("@/views/base-page/organization-select/index.vue")
const WxLogin = () => import("@/views/base-page/login/WxLogin.vue")
const Test = () => import("@/views/base-page/test/index.vue")

export const rootRoute: RouteRecordRaw = {
  path: "/",
  component: Layout,
  redirect: "/business/index",
  meta: {
    hidden: true,
  },
  children: [],
}

export const loginRoute: RouteRecordRaw = {
  path: "/login",
  component: Login,
  meta: {
    hidden: true,
  },
}

export const wxLoginRoute: RouteRecordRaw = {
  path: "/wx_login",
  component: WxLogin,
  meta: {
    hidden: true,
  },
}

export const organizationSelectRoute: RouteRecordRaw = {
  path: ORGANIZATION_SELECT_PATH,
  component: OrganizationSelect,
  meta: {
    hidden: true,
  },
}

export const noOrganizationRoute: RouteRecordRaw = {
  path: NO_ORGANIZATION_PATH,
  component: NoOrganization,
  meta: {
    hidden: true,
  },
}

export const testRoute: RouteRecordRaw = {
  path: "/test",
  component: Test,
  meta: {
    hidden: true,
  },
}

export const appRouter = [rootRoute, loginRoute, wxLoginRoute, noOrganizationRoute, organizationSelectRoute, testRoute]
